import Vue from 'vue'

const ViewerInstance = Vue.extend(require('./viewer.vue').default);
let instance = null

let getInstance = () => {
  return new ViewerInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
}

let Viewer = (source, now, type, canDownload = false) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  instance.open(source, now, type, canDownload)
}

export default Viewer
